export default __webpack_public_path__ + "static/media/image-work-team-w@2x.61d489b5.png";